import { render } from "./Devtool.vue?vue&type=template&id=5724de4d"
import script from "./Devtool.vue?vue&type=script&lang=js"
export * from "./Devtool.vue?vue&type=script&lang=js"

import "./Devtool.vue?vue&type=style&index=0&id=5724de4d&lang=css"
script.render = render

export default script